/* src/app/shared/components/ocr-progress-panel/ocr-progress-panel.component.css */
:host {
  display: contents;
}
.ocp {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 1100;
  width: min(380px, calc(100vw - 24px));
  font-family: "Inter Tight", sans-serif;
}
.ocp__card {
  background: var(--cf-surface, #fff);
  border-radius: 16px;
  box-shadow: 0 12px 36px rgba(20, 24, 40, .22);
  overflow: hidden;
  border: 1px solid var(--cf-border, #e5e7eb);
  animation: ocp-in .28s ease-out;
}
@keyframes ocp-in {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.ocp__head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 14px;
  background: var(--cf-chrome, #1e2235);
  color: #fff;
  cursor: pointer;
}
.ocp__badge {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  background: #e3fd64;
  color: #1a1d23;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}
.ocp__badge mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
}
.ocp__badge--busy {
  animation: ocp-glow 1.8s ease-in-out infinite;
}
@keyframes ocp-glow {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(227, 253, 100, .55);
  }
  50% {
    box-shadow: 0 0 0 7px rgba(227, 253, 100, 0);
  }
}
.ocp__head-text {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.ocp__head-text strong {
  font-family:
    "Bricolage Grotesk",
    "Inter Tight",
    sans-serif;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.2;
}
.ocp__head-text span {
  font-size: 12px;
  color: rgba(255, 255, 255, .7);
}
.ocp__chevron {
  color: rgba(255, 255, 255, .7);
}
.ocp__ghost {
  background: transparent;
  border: 0;
  padding: 4px;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  color: rgba(255, 255, 255, .75);
}
.ocp__ghost:hover {
  background: rgba(255, 255, 255, .12);
  color: #fff;
}
.ocp__ghost mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.ocp__ghost--dark {
  color: var(--cf-text-muted, #6b7280);
}
.ocp__ghost--dark:hover {
  background: var(--cf-bg, #f4f6f8);
  color: var(--cf-text, #1a1d23);
}
.ocp__list {
  list-style: none;
  margin: 0;
  padding: 8px;
  max-height: min(420px, 60vh);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: var(--cf-bg, #f4f6f8);
}
.ocp__item {
  background: var(--cf-surface, #fff);
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: 12px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.ocp__item-top {
  display: flex;
  align-items: center;
  gap: 10px;
}
.ocp__file-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
  color: var(--cf-text-muted, #6b7280);
  flex: 0 0 auto;
}
.ocp__file-icon mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.ocp__item-text {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.ocp__name {
  font-size: 13px;
  font-weight: 600;
  color: var(--cf-text, #1a1d23);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ocp__status {
  font-size: 12px;
  font-weight: 600;
  color: var(--cf-text-muted, #6b7280);
}
.ocp__item--work .ocp__file-icon {
  background: #fff7d6;
  color: var(--cf-brand-dark, #d48f00);
}
.ocp__item--wait .ocp__file-icon {
  background: #eef2ff;
  color: #4f46e5;
}
.ocp__item--ok .ocp__file-icon {
  background: #dcfce7;
  color: var(--cf-success, #16a34a);
}
.ocp__item--ok .ocp__status {
  color: var(--cf-success, #16a34a);
}
.ocp__item--warn .ocp__file-icon {
  background: #fef3c7;
  color: var(--cf-warning, #d97706);
}
.ocp__item--warn .ocp__status {
  color: var(--cf-warning, #d97706);
}
.ocp__item--bad .ocp__file-icon {
  background: #fee2e2;
  color: var(--cf-error, #dc2626);
}
.ocp__item--bad .ocp__status {
  color: var(--cf-error, #dc2626);
}
.ocp__bar {
  height: 6px;
  background: #eceff3;
  border-radius: 99px;
  overflow: hidden;
}
.ocp__bar-fill {
  height: 100%;
  background:
    linear-gradient(
      90deg,
      #e3fd64,
      #c4e83a);
  border-radius: 99px;
  transition: width .6s ease;
  position: relative;
}
.ocp__bar-fill::after {
  content: "";
  position: absolute;
  inset: 0;
  background:
    linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, .6),
      transparent);
  animation: ocp-shine 1.6s linear infinite;
}
@keyframes ocp-shine {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(100%);
  }
}
.ocp__steps {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}
.ocp__step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  position: relative;
  font-size: 10.5px;
  color: #9ca3af;
  text-align: center;
}
.ocp__step::before {
  content: "";
  position: absolute;
  top: 5px;
  right: 50%;
  width: 100%;
  height: 2px;
  background: #e5e7eb;
  z-index: 0;
}
.ocp__step:first-child::before {
  display: none;
}
.ocp__dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #e5e7eb;
  border: 2px solid #fff;
  box-sizing: content-box;
  position: relative;
  z-index: 1;
}
.ocp__step--done {
  color: var(--cf-text, #1a1d23);
}
.ocp__step--done .ocp__dot {
  background: var(--cf-success, #16a34a);
}
.ocp__step--done::before {
  background: var(--cf-success, #16a34a);
}
.ocp__step--current {
  color: var(--cf-text, #1a1d23);
  font-weight: 700;
}
.ocp__step--current .ocp__dot {
  background: #e3fd64;
  box-shadow: 0 0 0 2px #1a1d23 inset;
  animation: ocp-pulse 1.4s ease-in-out infinite;
}
.ocp__step--current::before {
  background: var(--cf-success, #16a34a);
}
@keyframes ocp-pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.25);
  }
}
.ocp__hint {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.4;
  color: var(--cf-text-muted, #6b7280);
}
.ocp__action {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: 0;
  cursor: pointer;
  background: #e3fd64;
  color: #1a1d23;
  font-weight: 700;
  font-size: 12.5px;
  padding: 7px 12px;
  border-radius: 8px;
  font-family: inherit;
}
.ocp__action:hover {
  background: #d3ee4f;
}
.ocp__action mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
@media (prefers-reduced-motion: reduce) {
  .ocp__card,
  .ocp__badge--busy,
  .ocp__bar-fill::after,
  .ocp__step--current .ocp__dot {
    animation: none;
  }
  .ocp__bar-fill {
    transition: none;
  }
}
@media (max-width: 480px) {
  .ocp {
    right: 8px;
    bottom: 8px;
    width: calc(100vw - 16px);
  }
}
/*# sourceMappingURL=ocr-progress-panel.component.css.map */
